export default "__VITE_ASSET__CnIyn1Nd__"